// app/javascript/dashboard/composables/useAiAnalytics.js
import { ref, computed } from 'vue';
import aiAnalyticsApi from 'dashboard/api/aiAnalytics';

export function useAiAnalytics() {
  const isLoading = ref(false);
  const error = ref(null);
  const data = ref(null);

  const fetchOverview = async ({ accountId, since, until, inboxId = null }) => {
    isLoading.value = true;
    error.value = null;
    try {
      const params = { since, until };
      if (inboxId) params.inbox_id = inboxId;
      const { data: response } = await aiAnalyticsApi.getOverview(accountId, params);
      data.value = response;
    } catch (e) {
      error.value = e.message || 'Erro desconhecido';
    } finally {
      isLoading.value = false;
    }
  };

  const conversations = computed(() => data.value?.conversations_started ?? 0);
  const aiOnly        = computed(() => data.value?.ai_only        ?? { count: 0, percentage: 0 });
  const transferred   = computed(() => data.value?.transferred    ?? { count: 0, percentage: 0 });
  const byUnit        = computed(() => data.value?.by_unit        ?? []);
  const topIntents    = computed(() => data.value?.top_intents    ?? []);
  const delta         = computed(() => data.value?.delta          ?? {});

  const avgDurationSeconds       = computed(() => data.value?.avg_duration_seconds ?? 0);
  const avgTimeToTransferSeconds = computed(() => data.value?.avg_time_to_transfer_seconds ?? 0);

  const formatSeconds = secs => {
    if (!secs || secs === 0) return '—';
    const h = Math.floor(secs / 3600);
    const m = Math.floor((secs % 3600) / 60);
    const s = secs % 60;
    if (h > 0) return `${h}h ${m}m`;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
  };

  const avgDurationFormatted       = computed(() => formatSeconds(avgDurationSeconds.value));
  const avgTimeToTransferFormatted = computed(() => formatSeconds(avgTimeToTransferSeconds.value));

  return {
    isLoading,
    error,
    fetchOverview,
    conversations,
    aiOnly,
    transferred,
    avgDurationFormatted,
    avgTimeToTransferFormatted,
    byUnit,
    topIntents,
    delta,
  };
}
